import {
  Button,
  IconChevronDown,
  IconHomebasedVenue,
  Inline,
  Stack,
  Text,
  useDevice,
  Viewport,
} from '@treatwell/ui';
import clsx from 'clsx';
import { Context } from 'js/components/LocaleWrapper';
import { CmsNearMePageType } from 'js/model/cms/cms-near-me-page';
import { NearMeCityType } from 'js/model/rainbow/near-me/NearMePageModel';
import React, { useContext, useState } from 'react';
import { trackCitySelection } from '../tracking';
import styles from './CityList.module.css';

const Cities = ({ cities }: { cities: NearMeCityType[] }) => (
  <ul className={styles.grid}>
    {cities.map((city) => (
      <li key={city.name}>
        <Text type="body">
          <a
            href={city.url}
            className={styles.link}
            onClick={(event) => {
              event.preventDefault();

              trackCitySelection(city.name).finally(() => {
                window.location.href = city.url;
              });
            }}
            data-cy="city-list-link"
          >
            {city.name}
          </a>
        </Text>
      </li>
    ))}
  </ul>
);

export const CityList = ({
  renderTitle,
}: {
  renderTitle: (title: string, className: string) => React.ReactElement;
}) => {
  const { pageData } = useContext(Context);
  const [showMore, setShowMore] = useState(false);
  const { isMobile, isDesktop } = useDevice();
  const cms: CmsNearMePageType = pageData.cms.page['near-me'];
  const cities = Array.from(pageData.nearMe.cities);
  const initialCities = cities.splice(0, 12);
  const showMoreCitiesId = 'show-more-cities';

  return (
    <div className={styles.root}>
      <Viewport device="mobile" serverRender={isMobile}>
        <Stack space="md" className={styles.titleContainer}>
          <IconHomebasedVenue size={16} className={styles.titleIcon} />
          <Text as="h3" type="mdHeader" className={styles.title}>
            {renderTitle(cms['city-list-title'], styles.highlight)}
          </Text>
        </Stack>
      </Viewport>
      <Viewport device={['tablet', 'desktop']} serverRender={isDesktop}>
        <Inline space="base" justify="center" className={styles.titleContainer}>
          <IconHomebasedVenue size={24} className={styles.titleIcon} />
          <Text as="h3" type="lgHeader" className={styles.title}>
            {renderTitle(cms['city-list-title'], styles.highlight)}
          </Text>
        </Inline>
      </Viewport>
      <Cities cities={initialCities} />
      {cities.length > 0 && (
        <>
          <div
            className={clsx(styles.nestedGrid, {
              [styles.expanded]: showMore,
            })}
            id={showMoreCitiesId}
          >
            <Cities cities={cities} />
          </div>
          <Button
            icon={<IconChevronDown size={24} />}
            iconPosition="right"
            className={styles.showMore}
            onClick={() => {
              setShowMore(!showMore);
            }}
            aria-expanded={showMore}
            aria-controls={showMoreCitiesId}
            data-cy="show-more"
          >
            {showMore ? cms['show-less-button'] : cms['show-more-button']}
          </Button>
        </>
      )}
    </div>
  );
};
